import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from "@angular/core";
import { Observable } from 'rxjs';
import { DOM436_API } from "src/app/app.api";
import { ClienteProjeto } from 'src/app/shared/model/cliente-projeto.model';
import { Cliente } from 'src/app/shared/model/cliente.model';
import { Contador } from 'src/app/shared/model/contador.model';
import { Financiamento } from 'src/app/shared/model/financiamento.model';
import { Navegacao } from '../model/navegacao.model';

@Injectable()
export class DataService {

    constructor(private http: HttpClient) {}

    listMetragens(): Observable<any> {
        return this.http.get(`${DOM436_API}/metragens/portal`)
    }

    listPlantas(): Observable<any> {
        return this.http.get(`${DOM436_API}/plantas/portal`)
    }

    listApartamentos(): Observable<any> {
        return this.http.get(`${DOM436_API}/apartamentos/portal`)
    }

    listSegmentacoes(): Observable<any> {
        return this.http.get(`${DOM436_API}/segmentacoes/portal`)
    }

    getSegmentacaoOpcoes(segmentacaoId: number): Observable<any> {
        return this.http.get(`${DOM436_API}/segmentacoes/${segmentacaoId}/opcoes/portal`)
    }

    listComodos(): Observable<any> {
        return this.http.get(`${DOM436_API}/comodos/portal`)
    }

    listComodosAtributos(): Observable<any> {
        return this.http.get(`${DOM436_API}/comodos/atributos/portal`)
    }

    listComodosAtributosVariacoes(): Observable<any> {
        return this.http.get(`${DOM436_API}/comodos/atributos/variacoes/portal`)
    }

    listAtributosAdicionais(): Observable<any> {
        return this.http.get(`${DOM436_API}/atributos-adicionais/portal`)
    }

    getConfiguracoesFinanciamento(): Observable<any> {
        return this.http.get(`${DOM436_API}/configuracoes/financiamentos/portal`)
    }

    calcularJuros(financiamento: Financiamento): Observable<any> {
        return this.http.post((`${DOM436_API}/configuracoes/financiamentos/calcular/portal`), JSON.stringify(financiamento), {headers: new HttpHeaders().set('Content-Type', 'application/json')})
    }

    getClienteByCodigoUrl(codigoUrl: string): Observable<any> {
        return this.http.get(`${DOM436_API}/clientes/${codigoUrl}/portal`)
    }

    saveCliente(cliente: Cliente): Observable<any> {
        return this.http.post((`${DOM436_API}/clientes/portal`), JSON.stringify(cliente), {headers: new HttpHeaders().set('Content-Type', 'application/json')})
    }

    saveConclusao(cliente: Cliente): Observable<any> {
        return this.http.post((`${DOM436_API}/clientes/confirmar/portal`), JSON.stringify(cliente), {headers: new HttpHeaders().set('Content-Type', 'application/json')})
    }

    ListProjetoByCliente(clienteId: number): Observable<any> {
        return this.http.get(`${DOM436_API}/clientes/${clienteId}/projetos/portal`)
    }

    saveClienteProjeto(clienteId: number, clienteProjetoList: ClienteProjeto[]): Observable<any> {
        return this.http.post((`${DOM436_API}/clientes/${clienteId}/projetos/portal`), JSON.stringify(clienteProjetoList), {headers: new HttpHeaders().set('Content-Type', 'application/json')})
    }

    incrementarContador(contador: Contador): Observable<any> {
        return this.http.post((`${DOM436_API}/apartamentos/contadores/portal`), JSON.stringify(contador), {responseType: 'text', headers: new HttpHeaders().set('Content-Type', 'application/json')})
    }

    incrementarNavegacao(navegacao: Navegacao): Observable<any> {
        return this.http.post((`${DOM436_API}/apartamentos/navegacoes/portal`), JSON.stringify(navegacao), {responseType: 'text', headers: new HttpHeaders().set('Content-Type', 'application/json')})
    }

    getCorretorByCodigoUrl(codigoUrl: string, userIp: string): Observable<any> {
        return this.http.get(`${DOM436_API}/corretores/${codigoUrl}/${userIp}/portal`)
    }
    
    getIpAddress() {
        return this.http.get("http://api.ipify.org/?format=json");
    }
}